export const zh = {
  msg:
    {
      'username': '用户名',
      'password': '密码',
      'login': '登录',
      'username_not_found': '请输入您的用户名',
      'password_not_found': '请输入您的密码',
      'error': '用户名或密码无效。。',
      'changeLanguage': '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      'submit_button_text': '提交',
      'enter': '登录',
      'en': 'English',
      'ms': 'Bahasa Melayu',
      'zh': 'Chinese',
      'ta': 'Tamil',
      'km': 'Khmer',
      'th': 'Thai',
      'id': 'Bahasa Indonesia',
      'ar': 'Arabic',
      'blank_username_field': '请输入您的用户名。',
      'blank_password_field': '请输入您的密码。',
      'invalid_credentials': '用户名或密码无效。',
      'copyright': '由Global Psytech提供技术支持'
    }
}
